// extracted by mini-css-extract-plugin
export default {"container":"V_-z","productName":"W_-z","price":"X_-z","dimensions":"Y_-z"};